import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_NAME = `${REPORT}_SET_NAME`;
export const SET_FORMAT = `${REPORT}_SET_FORMAT`;
export const SET_REPORT_ID = `${REPORT}_SET_REPORT_ID`;
export const RESET = `${REPORT}_RESET`;



// WEBPACK FOOTER //
// ./src/views/ReportFilters/flow/actionTypes.js